import { stripHtml as getStripHtml } from 'string-strip-html';

export const stripHtml = (value: string): string => {
  return getStripHtml(value).result;
};
